<template>
  <div>
    <Head title="Ruta | Clientes" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/routes">Rutas</Link>
      <span class="text-sky-400 font-medium">/</span> Clientes
    </h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">          
          <th class="pb-4 pt-6 px-2">Ruta</th>            
          <th class="pb-4 pt-6 px-2">Descripción cliente</th>
          <th class="pb-4 pt-6 px-2">Estatus</th>
        </tr>
        <tr v-for="client in clients.data" :key="client.id" class="hover:bg-gray-100 focus-within:bg-gray-100"> 
          <td class="border-t">
            <p class="flex items-center px-6 py-4">
              {{ getRouteDescription(client.id_route) }}
            </p>
          </td><td class="border-t">
            <p class="flex items-center px-6 py-4">
              {{ getClientDescription(client.id_client) }}
            </p>
          </td>         
          <td class="border-t">
            <p class="flex items-center px-6 py-4">
              {{ client.estatus }}
            </p>
          </td>
        </tr>
        <tr v-if="clients.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">No se encontraron clientes para esta ruta.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="clients.links" />
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import DialogInput from '@/Shared/Dialog'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Search from '@/Shared/Search'
import Pagination from '@/Shared/Pagination'
import Swal from 'sweetalert2'
  
export default {
  components: {
    Head,
    Link,
    DialogInput,
    LoadingButton,
    SelectInput,
    Search,
    Pagination,
  },
  layout: Layout,
  props: {    
    clients: Array,  
    clie: Array,    
    allClients: Array,
    clientsWithoutRoute: Array,
    routeClients: Array,
    routeId: String,
    allRoute:Array,   
    codes: Object, 
    families: Object,
    categories: Object,      
  },
  remember: 'form',
  data() {
    return {
      
    }
  },  
  methods: {
    getRouteDescription(number) {
      const route = this.allRoute.find(cat => cat.id === number)
      return route ? route.descripcion : 'Ruta no disponible'
    },   
    getClientDescription(number){
      const client = this.allClients.find(cat=> cat.id=== number)
      return client ? client.cliente: 'Cliente no disponible'
    },
  },
}   
</script>